import React, { FC } from 'react';
import styled from 'styled-components';
import { Space } from 'udesk-ui';
import Udesk from 'Udesk';
import CustomModelsSelect from 'src/components/common/CustomModelsSelect';
import CustomModelsQaMethod from 'src/components/common/CustomModelsQaMethod';
import TicketRelateQa from 'src/components/common/TicketRelateQa';
import { AiModelFoundResponse } from 'src/api/types';

const Wrapper = styled.div`
    background-color: rgb(247, 247, 247);
    padding: 16px;
`;

type TemplateProps = {
    modelId?: number;
    onModelChange?: (v?: AiModelFoundResponse) => void;
    aiBatchQa?: number;
    onQaMethodChange?: (v?: number) => void;
    onTicketRelateQaChange?: (v?: number) => void;
    disabled?: boolean;
    ticketRelateQa?: number;
    /** 质检数据源，仅工单质检任务展示检测数据 */
    inspectDataSource?: number;
};

const Template: FC<TemplateProps> = (props) => {
    const {
        modelId,
        onModelChange,
        aiBatchQa,
        onQaMethodChange,
        disabled = false,
        ticketRelateQa,
        onTicketRelateQaChange,
        inspectDataSource,
    } = props;

    const showTicketRelateQa =
        inspectDataSource === Udesk.enums.inspectDataSources.ticket.id;

    return (
        <Wrapper>
            <Space>
                <CustomModelsSelect
                    onChange={onModelChange}
                    value={modelId}
                    disabled={disabled}
                    showTip
                />

                <CustomModelsQaMethod
                    value={aiBatchQa}
                    onChange={onQaMethodChange}
                    disabled={disabled}
                />

                {showTicketRelateQa ? (
                    <TicketRelateQa
                        value={ticketRelateQa}
                        onChange={onTicketRelateQaChange}
                        disabled={disabled}
                    />
                ) : null}
            </Space>
        </Wrapper>
    );
};

export default Template;
